<template>
  <div class="claims-page-content main-content wide">
    <div class="wrap">
      <sidebar-left v-if="showSidebar && !isMobile" />

      <div :class="['main-block', { 'with-sidebar': showSidebar && !isMobile }]">
        <div class="content">
          <form-header
            :link-title="claimListTitle"
            :title="activeTitle"
            :description="activeDescription"
            :steps="activeInfo"
            :hide-back-link="hideBackLink"
            :show-sub-items="showHeader"
            @goBack="goToSilo"
          />

          <template v-if="getStep === 'pnr-form'">
            <pnr-view
              :info-box-description="infoBoxDescription"
              :info-box-c-t-a="infoBoxCTA"
            />
          </template>

          <template v-else>
            <component
              :is="getStep"
              :active-item="activeStep"
            />
          </template>
        </div>

        <info-block
          v-if="!showSidebar"
          :list="pageData.infoBlock.list"
          :note="pageData.infoBlock.note"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import isEmpty from 'lodash-es/isEmpty'
  import FormHeader from 'components/Forms/FormHeader'
  import ScrollUtils from 'utils/scrollUtils'

  export default {
    components: {
      'sidebar-left': () => import(/* webpackChunkName: "sidebar-left" */ 'components/Sidebar/Sidebar'),
      'silo': () => import(/* webpackChunkName: "claims-silo" */ 'containers/Pages/Claims/Silo'),
      'default-form': () => import(/* webpackChunkName: "claims-form" */ 'containers/Pages/Claims/Forms/Default'),
      'files-form': () => import(/* webpackChunkName: "claims-form" */ 'containers/Pages/Claims/Forms/FilesUploadForm'),
      'pnr-view': () => import(/* webpackChunkName: "pnr-form" */ 'containers/Pages/Claims/PnrValidation'),
      FormHeader,
      'info-block': () => import(/* webpackChunkName: "info-block" */ 'containers/Pages/Claims/InfoBlock'),
    },

    computed: {
      ...mapState('claims', [
        'activeStep',
        'pageData',
        'pnrFilled',
        'formLayoutData',
        'formName'
      ]),
      ...mapState('claims/pnr', [
        'infoBoxDescription',
        'infoBoxCTA'
      ]),
      ...mapGetters('device', [
        'isMobile'
      ]),

      showHeader () {
        return this.activeStep !== '' && ( this.activeStep ===  '' ? this.pnrFilled : true)
      },

      getStep () {
        if (isEmpty(this.activeStep)) {
          return 'silo'
        }

        if (this.activeStep.key === 'files') {
          return 'files-form'
        }

        if (!this.pnrFilled) {
          return 'pnr-form'
        }

        return 'default-form'
      },
      showSidebar () {
        return this.getStep === 'silo'
      },

      activeTitle () {
        if (isEmpty(this.activeStep)) {
          return this.pageData.title
        }

        if (this.activeStep.key === 'files') {
          return this.formLayoutData.fileUploadTitle
        }

        return this.activeStep.title || ''
      },

      activeDescription () {
        if (isEmpty(this.activeStep)) {
          return this.pageData.description
        }

        if (this.activeStep.key === 'files') {
          return this.formLayoutData.fileUploadDescription
        }

        return this.activeStep.description || ''
      },

      activeInfo () {
        if (isEmpty(this.activeStep)) {
          return this.pageData.info
        }

        return this.activeStep.info || ''
      },

      hideBackLink () {
        return isEmpty(this.activeStep) || this.activeStep.key === 'files'
      },
      claimListTitle () {
        return this.$t('claims.backToFullClaimsList')
      }
    },
    watch: {
      activeStep() {
        ScrollUtils.smoothScroll(0, 300)
      }
    },
    methods: {
      goToSilo () {
        this.$store.dispatch('claims/clearAllData')
        this.$store.commit('claims/pnr/removeErrors')
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .claims-page-content {
    padding: 20px 0 20px;

    @include bp-tablet-only {
      padding-top: 37px;
    }

    @include bp-mf-desktop {
      padding: 40px 0 72px;
    }

    .wrap {
      display: flex;
      flex-direction: column;
      @include clearfix();

      @include bp-mf-desktop {
        display: block;
      }
    }
  }

  .main-block {
    display: flex;
    flex-direction: column;
    order: 0;
    padding: 0 0 28px;
    margin-top: 0;
    width: 100%;

    @include bp-mf-tablet {
      padding: 0 26px 26px;
      margin-top: -11px;
    }

    @include bp-mf-desktop {
      padding: 0 0 68px;
      flex-direction: row;
      justify-content: space-between;
      margin-top: -21px;
    }

    &.with-sidebar {
      @include bp-mf-tablet {
        margin-top: 0;
      }

      @include bp-desktop-small {
        position: relative;
        top: 0;
      }

      @include bp-mf-desktop {
        position: relative;
        float: left;
        vertical-align: top;
        width: 66%;

        .content {
          width: 100%;
        }
      }
    }
  }

  .content {
    @include bp-mf-desktop {
      width: 58%;
    }
  }
</style>
